import { DateTime } from 'luxon';

const LAST_THREE_DAYS_BOUND = 3;

export const areLastThreeDaysInActualMonth = () => {
   const currentDate = DateTime.now();
   return currentDate.daysInMonth - currentDate.day <= LAST_THREE_DAYS_BOUND;
};
